import { useFormContext } from '@sravni/cosago-react-library/lib/hooks';
import type { FieldValues } from '@sravni/react-silent-authentication-form';
import { useEffect } from 'react';

/*
 * Хук запускает валидацию и покажет пользователю поля которые пользователю нужно заполнить
 * использует внутри себя useFormContext поэтому используем только там где есть доступ к нему
 */
export const useFormTriggerWhenFormForcedOpen = <T extends FieldValues>(isFormForceOpened: boolean | undefined) => {
  const { trigger } = useFormContext<T>();

  useEffect(() => {
    if (isFormForceOpened) trigger();
  }, [trigger, isFormForceOpened]);
};
